import { useEffect } from 'react';

export const useScrollToTop = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  // Return a simple scroll function
  return () => window.scrollTo({ top: 0, behavior: 'smooth' });
};
